import getActionCable, { createWebsocketListener } from '../../../utils/actioncable';
import { actions } from './index';
import { setDisplayedIncidentId } from '../dashboards/actions';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';

const connections = new Set();
const options = {
  name: 'incidents',
  baseType: 'INCIDENTS',
  apiEndpoint: 'incidents'
};

const defaultOperations = createMetadataAPIOperations(options);

// bound actions
export const registerForIncidentUpdates = (groupIds, actionCable) => dispatch => {
  // don't allow more than 1 connection for the same group
  if (connections.has(groupIds)) return;

  connections.add(groupIds);

  const channelData = {
    channel: 'IncidentNotificationsChannel',
    group_ids: groupIds ? String(groupIds) : null
  };

  // const callAPI = () => {
  //   const updated_after = moment().subtract(5, 'minute').toISOString();
  //   dispatch(defaultOperations.fetch({ forceFetch: true, params: { updated_after } }));
  // };

  const connectHandler = () => console.log(`Connected to IncidentNotificationsChannel with groupIds ${groupIds}!`);

  const receivedHandler = data => {
    dispatch(actions.fetchSuccessful([data], { replace: false }));
    dispatch(setDisplayedIncidentId(data.id));
  };

  const retryHandler = () => registerForIncidentUpdates(groupIds, actionCable);

  const cleanupHandler = () => connections.delete(groupIds);

  const listener = createWebsocketListener({
    dispatch,
    connectHandler,
    receivedHandler,
    retryHandler,
    cleanupHandler,
    fallbackPoller: null, // Poller disabled; restore with callAPI
    fallbackPollerInterval: 5000
  });

  try {
    actionCable = actionCable || getActionCable();
    actionCable.subscriptions.create(channelData, listener);
  } catch (error) {
    console.log(error);
  }
};

export default {
  ...defaultOperations,
  registerForIncidentUpdates
};
